"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateStyle = exports.selectBestPreset = exports.getWindowSize = exports.usePortalDOMNodeRef = void 0;
const react_1 = require("react");
const calculators_1 = require("./calculators");
const PopoverContext_1 = require("./PopoverContext");
const usePortalDOMNodeRef = (zIndex) => {
    const portalDOMNodeRef = (0, react_1.useRef)(null);
    const popoverViewContext = (0, react_1.useContext)(PopoverContext_1.PopoverContext);
    if (!portalDOMNodeRef.current) {
        portalDOMNodeRef.current = popoverViewContext.getPortalDOMNode(zIndex);
    }
    return portalDOMNodeRef;
};
exports.usePortalDOMNodeRef = usePortalDOMNodeRef;
const calculatePosition = ({ preset, targetRect, popoverRect, portalPosition }) => {
    const offset = { left: preset.offsetX || 0, top: preset.offsetY || 0 };
    return {
        left: calculators_1.OFFSET_CALCULATORS.x[preset.xAxis]({
            targetRect,
            popoverRect,
            portalPosition,
            offset
        }),
        top: calculators_1.OFFSET_CALCULATORS.y[preset.yAxis]({
            targetRect,
            popoverRect,
            portalPosition,
            offset
        })
    };
};
const getWindowSize = () => {
    return {
        width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
        height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
    };
};
exports.getWindowSize = getWindowSize;
const selectBestPreset = ({ presets, targetRect, popoverRect, portalPosition, viewportAccuracyFactor, windowSize }) => {
    let resultPreset = presets[0];
    let bestViewportAccuracyFactor = 0;
    if (typeof window !== 'undefined' && presets.length > 1) {
        const windowWidth = windowSize.width;
        const windowHeight = windowSize.height;
        presets.some((preset) => {
            const position = calculatePosition({ preset, targetRect, popoverRect, portalPosition });
            const rect = Object.assign({ width: popoverRect.width, height: popoverRect.height }, position);
            const left = Math.max(rect.left, 0);
            const right = Math.min(rect.left + rect.width, windowWidth);
            const top = Math.max(rect.top, 0);
            const bottom = Math.min(rect.top + rect.height, windowHeight);
            const rectArea = rect.width * rect.height;
            const visibleRectArea = (right - left) * (bottom - top);
            const currentViewportAccuracyFactor = visibleRectArea / rectArea;
            if (currentViewportAccuracyFactor >= viewportAccuracyFactor) {
                resultPreset = preset;
                return true;
            }
            if (currentViewportAccuracyFactor > bestViewportAccuracyFactor) {
                bestViewportAccuracyFactor = currentViewportAccuracyFactor;
                resultPreset = preset;
            }
            return false;
        });
    }
    return resultPreset;
};
exports.selectBestPreset = selectBestPreset;
var POSITION_STYLE;
(function (POSITION_STYLE) {
    POSITION_STYLE["absolute"] = "absolute";
})(POSITION_STYLE || (POSITION_STYLE = {}));
var VISIBILITY_STYLE;
(function (VISIBILITY_STYLE) {
    VISIBILITY_STYLE["hidden"] = "hidden";
    VISIBILITY_STYLE["visible"] = "visible";
})(VISIBILITY_STYLE || (VISIBILITY_STYLE = {}));
const calculateStyle = ({ preset, targetRect, popoverRect, portalPosition, offset, windowSize }) => {
    const style = {
        position: POSITION_STYLE.absolute,
        visibility: VISIBILITY_STYLE.hidden,
        maxHeight: undefined
    };
    if (!preset || !popoverRect) {
        return style;
    }
    const xOffsetCalculator = calculators_1.OFFSET_CALCULATORS.x[preset.xAxis];
    const yOffsetCalculator = calculators_1.OFFSET_CALCULATORS.y[preset.yAxis];
    const position = {
        left: xOffsetCalculator({ targetRect, popoverRect, portalPosition, offset }),
        top: yOffsetCalculator({ targetRect, popoverRect, portalPosition, offset })
    };
    if (position.top < 0) {
        style.maxHeight = `${((popoverRect === null || popoverRect === void 0 ? void 0 : popoverRect.height) || 0) + position.top}px`;
        position.top = 0;
    }
    if (((windowSize === null || windowSize === void 0 ? void 0 : windowSize.height) || 0) - position.top < popoverRect.height) {
        style.maxHeight = `${((windowSize === null || windowSize === void 0 ? void 0 : windowSize.height) || 0) - position.top}px`;
    }
    const positionStyles = {
        left: `${position.left}px`,
        top: `${position.top}px`
    };
    return Object.assign(Object.assign(Object.assign({}, style), positionStyles), { visibility: VISIBILITY_STYLE.visible });
};
exports.calculateStyle = calculateStyle;
//# sourceMappingURL=helpers.js.map